<template>
    <span class="sendText">
        <b-btn class="font-weight-bold" :disabled="disabled" block :variant="disabled ? 'secondary' : 'warning'" @click="model = true">
            Asign Delivery Driver
        </b-btn>
        <c-modal
            v-model="model"
            cancel-label="Never mind"
            centered size="md"
            title="Assign Delivery Driver"
            :tag="false"
            confirm-label="Save"
            :progressing="progressing"
            @submit="submit"
        >
            <template>
                <div>
                    <b-form-group>
                        <b-input-group prepend="Driver Name">
                            <b-form-select
                                name="Driver Name"
                                v-validate="'required'"
                                :options="drivers"
                                :disabled="drivers.length===0 || NoDriverError"
                                v-model="selectedDriver"/>
                                
                        </b-input-group>
                    </b-form-group>
                    
                    
                    <b-alert :show="NoDriverError" variant="danger" class="px-4 my-3">
                        No drivers found for this account
                    </b-alert>
                    <b-alert :show="errors.any()" variant="danger" class="px-4 my-3">
                <ul class="m-0 px-1">
                    
                    <li v-for="err in errors.all()" :key="err">{{err}}</li>
                </ul>
            </b-alert>
                </div>
            </template>
        </c-modal>
    </span>
</template>

<script>
    import CModal from "./Cmodal";
    export default {
        name: "AsignDeliveryDriver",
        components: {CModal},
        props: {
            disabled: {
                default: false,
                type: Boolean,
                default: false
            },
            messages: {
                type: Array,
                default: []
            },
            orderId: {
                required: true
            }
        },
        
        data () {
            return {
                model: false,
                progressing: false,
                drivers:[],
                selectedDriver:"",
                NoDriverError:false,
                

            }
        },
        watch:{
            model(newVal){
                if(newVal)
                    this.loadDrivers()
            },
          
        },
        methods: {
            submit () {
                
                if(this.selectedDriver != "None" && this.selectedDriver!= "Pickup Tab" && !this.NoDriverError){
                    
                    let filter = {
                        RestaurantID:this.$store.state.selectedRestaurantId,
                        UserID:localStorage.getItem('userID'),
                        OrderID:this.orderId,
                        ServerName:this.selectedDriver
                        
                    }
                    this.progressing = true
                    
                    this.$api.getRestaurant.UpdateOrderServerName(filter).then(res=>{
                        this.model=false
                        this.progressing = false
                    }).catch(err=>{
                        //console.log(err)
                    })
                    
                    this.progressing = false
                    
                }
                this.model = false



            },
            loadDrivers(){
                this.NoDriverError = false
                this.progressing = true
                let filter = {
                    RestaurantID:this.$store.state.selectedRestaurantId,
                    UserID:localStorage.getItem('userID')
                }
                

                
                this.$api.getRestaurant.GetDashboardRestaurantClient(filter).then(res=>{
                    
                    let tmp = res.RestaurantClients.filter(el=>el.RoleID === 14)
                    if(tmp.length > 0){
                        let drivers = []

                        

                        tmp.forEach(el => {
                            drivers.push({
                                text:el.FirstName+" "+el.LastName,
                                value:el.FirstName+" "+el.LastName  
                            })
                        })
                        
                        this.drivers = drivers
                        
                        
                        
                    }
                    

                }).catch(err=>{
                    //console.log(err)
                })
                
                filter = {
                    RestaurantID:this.$store.state.selectedRestaurantId,
                    OrderID:this.orderId
                }



                this.$api.getRestaurant.GetRestaurantCurrentOrders(filter).then(res=>{
                    if(res.success && res.orderInfo.ServerName !="Pickup Tab"){
                        if(this.drivers.length > 0){

                            this.NoDriverError = false
                            this.selectedDriver = res.orderInfo.ServerName
                        }
                        else if(this.drivers.length === 0){
                            this.NoDriverError = true
                        }
                    }
                }).catch(err=>{
                    //console.log("err: ", err)
                })
                this.progressing = false
            }
        }
                
    }
</script>

<style scoped>

</style>
